export default __webpack_public_path__ + "static/media/us-confederate_battle.f3281349.svg";